import React from 'react'
import PropTypes from 'prop-types'
import Icon from '../Icon'

/**
* Chevron icon.
*/
function ChevronIcon(props) {
  const {
    isUp, isDown, isLeft, isRight, ...rest
  } = props

  let name; let
    content

  // Left chevron
  if (isLeft) {
    name = 'chevron-left'
    content = (
      <g><path d="M13.295,24l1.41,-2.82l-4.58,-9.18l4.58,-9.18l-1.41,-2.82l-6,12l6,12Z" /></g>
    )
  // Right chevron
  } else if (isRight) {
    name = 'chevron-right'
    content = (
      <g><path d="M10.705,0l-1.41,2.82l4.58,9.18l-4.58,9.18l1.41,2.82l6,-12l-6,-12Z" /></g>
    )
  // Up chevron
  } else if (isUp) {
    name = 'chevron-up'
    content = (
      <g><path d="M0,13.295l2.82,1.41l9.18,-4.58l9.18,4.58l2.82,-1.41l-12,-6l-12,6Z" /></g>
    )
  // Default to down chevron.
  } else {
    name = 'chevron-down'
    content = (
      <g><path d="M24,10.705l-2.82,-1.41l-9.18,4.58l-9.18,-4.58l-2.82,1.41l12,6l12,-6Z" /></g>
    )
  }

  return (
    <Icon
      icon={name}
      aria-hidden
      role="presentation"
      {...rest}
    >
      {content}
    </Icon>
  )
}

ChevronIcon.defaultProps = {
  isUp: false,
  isDown: false,
  isLeft: false,
  isRight: false,
}

ChevronIcon.propTypes = {
  isUp: PropTypes.bool,
  isDown: PropTypes.bool,
  isLeft: PropTypes.bool,
  isRight: PropTypes.bool,
}

export default ChevronIcon
